import { Button } from "@mui/material";
import { makeStyles } from "@mui/styles";

import React from "react";

const useStyles: any = makeStyles((theme: any) => ({

  root: (props: any) => {
    const { white, red, width = 169, marginRight, uppercase, bold, onClick, ...otherprops } = props;
    const purple = theme.gradiants.button;
    const pressedWhite = theme.gradiants.pressedWhite;
    const textTransform = uppercase ? "uppercase" : "capitalize";

    return {
      height: 40,
      minWidth: width || 169,
      fontSize: 16,
      fontWeight: white || bold ? 500 : "normal",
      lineHeight: "normal",
      color: white ? theme.palette.primary.intermidiate : "#fff",
      textTransform,
      borderRadius: 4,
      background: white || red ? white ? "#fff" : "#f05347" : purple,
      border: white ? "solid 1px #413044" : undefined,
      marginRight: marginRight ? 20 : undefined,
      "&:hover": {
        background: white || red ? white ? pressedWhite : "rgba(240, 83, 71, 0.9)" : purple
      },
      "&:focus": {
        background: white || red ? white ? pressedWhite : "rgba(240, 83, 71, 0.9)" : purple
      },
      "&:disabled": {
        background: white || red ? white ? "#fff" : "#f4867e" : theme.gradiants.disabledButton,
        border: white ? "solid 1px #aaa2aa" : undefined,
        color: white ? theme.palette.primary.intermidiate : "#fff"
      }
    };
  },
  title: {
    flexGrow: 1
  }
}));

const StyledButton = (props: any) => {
  const { white, red, width = 169, marginRight, uppercase, bold, onClick, ...otherprops } = props;
  const { root } = useStyles(props);

  return <Button disableRipple disableElevation classes={{ root }} onMouseUp={onClick} {...otherprops}>{props.children}</Button>;
};

export default StyledButton;
